import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Viewer, Note } from './models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
}

@Injectable()
export class LessonService {

    viewers$: Observable<Array<Viewer>>;
    errors$: Observable<string>;

    private _currentVideoTimeSeconds: number;
    constructor(
        private _http: HttpClient
    ) {

    }

    get CurrentVideoTimeSeconds(): number {
        return this._currentVideoTimeSeconds;
    }

    set CurrentVideoTimeSeconds(index: number) {
        this._currentVideoTimeSeconds = index;
    }

    fetchViewer(lessonAssignmentId: number): Observable<Viewer> {
        return this._http.get('api/lesson/getLesson/' + lessonAssignmentId).pipe(
            map(response => new Viewer(response))
        );
    }

    updateLessonStatusAsComplete(lessonAssignmentId: number): Observable<boolean> {
        return this._http.get('api/lesson/lessonComplete/' + lessonAssignmentId).pipe(
            map(response => <boolean>response)
        );
    }

    // getNote(lessonAssignmentId): Observable<Note> {
    //     return this._http.get('api/lesson/note/' + lessonAssignmentId).pipe(
    //         map(response => new Note(response))
    //     );
    // }

    saveNote(n: Note): Observable<number> {
        return this._http.post('api/lesson/saveNote', JSON.stringify(n), httpOptions).pipe(
            map(response => <number>response)
        );
    }
}
